import { i18n } from '@src/plugins'

export default function teamProfiles() {
    const staffProfiles = [
        'CustomerSuccess',
        'Admin',
        'Educator',
        'Support',
        'Responsible',
        'Student',
        'Seller',
        'Marketing',
        'Developer',
    ]
    const profiles = i18n.t('Profiles')
    const filteredProfiles = profiles.filter(
        ({ textShow }) => !staffProfiles.includes(textShow)
    )
    return filteredProfiles
}